import { type KeyValueStore, readStored, writeStored } from '@reconforta/teleconsultation-core'
import { safeLocalStorage } from './local-store.ts'

const STORAGE_KEY = 'reconforta-session-changed-at'

export function markSessionChanged(store: KeyValueStore | null = safeLocalStorage()): void {
  writeStored(store, STORAGE_KEY, String(Date.now()))
}

export function reloadWhenSessionChanged(
  store: KeyValueStore | null = safeLocalStorage(),
  reload: () => void = () => window.location.reload(),
): (event: Pick<PageTransitionEvent, 'persisted'>) => void {
  const drawnAt = readStored(store, STORAGE_KEY)

  return (event) => {
    if (event.persisted && readStored(store, STORAGE_KEY) !== drawnAt) reload()
  }
}
